<template>
  <template v-if="apiData.offers?.length">
    <div class="grid">
      <div
          class="g-col-12 devis-intro"
          v-html="apiData.prestationText"
      ></div>
      <template v-for="offer in apiData.offers" :key="offer.slug">
        <OfferItem :offer="offer" class="g-col-12 g-col-xl-6 g-col-xxl-4" />
      </template>
      <template v-for="service in apiData.services" :key="service.slug">
        <ServiceItem
          :service="service"
          class="g-col-12 g-col-xl-6 g-col-xxl-4"
        />
      </template>
    </div>
  </template>
  <div class="devis-btn-group" style="margin-top: 50px">
    <button
      type="button"
      class="devis-btn devis-btn--white"
      @click="goStep(values.moveMeter ? 2 : 3)"
    >
      {{ __('Previous step', 'smdt') }}
    </button>
    <button
      type="button"
      class="devis-btn"
      :disabled="!canNext"
      @click="goStep(5)"
    >
      {{ __('Next step', 'smdt') }}
    </button>
  </div>
</template>

<script>
import { mapActions, mapState, mapWritableState } from 'pinia'
import { useStagesStore } from '../stores/stages'
import OfferItem from '../components/OfferItem.vue'
import ServiceItem from '../components/ServiceItem.vue'

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

export default {
  name: 'StageFive',
  components: { ServiceItem, OfferItem },
  computed: {
    ...mapWritableState(useStagesStore, ['values']),
    ...mapState(useStagesStore, ['apiData', 'canNext']),
    offerPosts() {
      return this.apiData.offers
    },
    valid() {
      return this.values.offer
    },
  },
  watch: {
    valid(newVal) {
      this.setValid(newVal)
    },
  },
  mounted() {},
  methods: {
    ...mapActions(useStagesStore, ['setValid', 'goStep']),
    __,
  },
}
</script>

<style scoped lang="scss">
.grid {
  @include media-breakpoint-down(md) {
    --vn-gap: 20px 0;
  }
}
</style>
